import React from "react";
import { Building2 } from "lucide-react";

const CompanyAdminIcon = (props: any) => <Building2 {...props} />;

export default CompanyAdminIcon;
